$('#header-menu-toggle').on('click', function() {
    $(this).toggleClass('is-open');

    $('#header-menu').slideToggle(200);

    return false;
});